import { m } from "framer-motion";

export const mentalplus = {
  mentalplus_tab_help: 'Ma bouée',
  mentalplus_tab_videos: 'Vidéos',
  mentalplus_tab_home: 'Mon monde',
  mentalplus_tab_evolution: 'Mon évolution',
  mentalplus_filtre_ile: 'Île',
  mentalplus_tab_ile_moi: 'Moi',
  mentalplus_tab_ile_amour: 'Amour',
  mentalplus_tab_ile_famille: 'Famille',
  mentalplus_tab_ile_amis: 'Amis',
  mentalplus_tab_ile_ecrans: 'Écran',
  mentalplus_tab_ile_loisirs: 'Loisirs',
  mentalplus_video_filtres: 'Filtres',
  mentalplus_video_enregistrees: 'Enregistrées',
  mentalplus_videos_enregistrees: 'Vidéos enregistrées',
  mentalplus_video_rechercher:  'Rechercher',
  mentalplus_help_signes: 'Signes',
  mentalplus_help_solutions: 'Solutions',
  mentalplus_help_num_soutiens: 'Numéros de soutiens',
  mentalplus_help_signes_question: 'Quels sont les signes qui me font prendre conscience que je commence à aller mal ?',
  mentalplus_help_solutions_question: 'Quelles solutions peuvent m’aider à aller mieux ?',
  mentalplus_help_num_epingle: 'Numéro épinglé',
  mentalplus_help_num_epingle_choix: 'Choisir le numéro à épingler',
  mentalplus_help_num_valider: 'Valider ce numéro',
  mentalplus_help_num_gerer:  'Gérer mes numéros d’urgence',
  mentalplus_help_num_gerer_proches:  'Gérer mes numéros de proches',
  mentalplus_help_num_enregistrer: 'Enregistrer',
  mentalplus_help_solutions_ajouter: 'Ajouter une solution',
  mentalplus_help_ajouter: 'Ajouter',
  mentalplus_help_signes_ajouter: 'Ajouter un signe',
  mentalplus_help_num_proches_ajouter: 'Ajouter un proche',
  mentalplus_help_num_proches_nom: 'Nom du proche (ex : Papa)',
  mentalplus_help_num_proches_nom_numero: 'Numéro de téléphone',
  mentalplus_help_num_urgences: 'Numéros d’urgence',
  mentalplus_help_num_utiles: 'Numéros utiles',
  mentalplus_help_num_proches: 'Proches',
  mentalplus_video_retour: 'Retour',
  mentalplus_video_tout_voir: 'Tout voir',
  mentalplus_video_renitialiser: 'Rénitialiser',
  mentalplus_filtre_categories: 'Catégories',
  mentalplus_filtre_categories_explications: 'Explications',
  mentalplus_filtre_categories_solutions: 'Solutions',
  mentalplus_filtre_realisee: 'Réalisée par',
  mentalplus_filtre_realisee_professionnels: 'Professionnels',
  mentalplus_filtre_realisee_communaute: 'Communauté',
  mentalplus_filtre_realisee_2: 'Réalisée pour',
  mentalplus_filtre_realisee_collegiens: 'Collégiens',
  mentalplus_filtre_realisee_lyceens: 'Lycéens',
  mentalplus_filtre_realisee_etudiants: 'Étudiants',
  mentalplus_filtre_realisee_jeunes_actifs: 'Jeunes actifs',
  mentalplus_filtre_realisee_sans_activite: 'Sans activité',
  mentalplus_filtre_trier: 'Trier par',
  mentalplus_filtre_trier_popularite: 'Popularité',
  mentalplus_filtre_trier_recent: 'Récent',
  mentalplus_filtre_trier_ancien: 'Ancien',
  mentalplus_menu_profile: 'Profil',
  mentalplus_menu_island_settings: 'Paramètres de l’île',
  mentalplus_menu_share: 'Partager Mental+',
  menu_share: 'Partager',
  mentalplus_menu_conatct: 'Nous Contacter',
  mentalplus_menu_objet: 'Objet',
  mentalplus_menu_objet_champ: 'Selectionnez un objet',
  mentalplus_menu_equipe: 'Qui sommes-nous ?',
  mentalplus_menu_signaler_un_bug: 'Signaler un bug',
  mentalplus_menu_contacter_l_equipe: 'Contacter l’équipe',
  mentalplus_menu_autre: 'Autre',
  mentalplus_menu_que_faire: 'Que faire ?',
  mentalplus_menu_Son: 'Son',
  mentalplus_video_recherche: 'Aucune vidéo ne correspond à ces filtres.',
  mentalplus_ile_moi_quizz: 'Quiz anxiété dépression',
  mentalplus_video_enregistree: 'Aucune vidéo enregistrée pour le moment.',
};
